import React from 'react';
import { ChooseSubstitutionScreen } from '@/screens/substitutions/choose-substitution-screen';
import { createStackNavigator } from '@react-navigation/stack';
import { SearchCatalogScreen } from '@/screens/substitutions/search-catalog-screen';
import { SelectSubstitutionQuantity } from '@/screens/substitutions/select-substitution-quantity';
import { SUBSTITUTION_ROUTES } from './routes';
import { SubstitutionStackParams } from './types';
import { useDefaultStackScreenOptions } from '@/hooks/use-default-stack-screen-options';

const Stack = createStackNavigator<SubstitutionStackParams>();

export const SubstitutionStack: React.FC = () => {
  const screenOptions = useDefaultStackScreenOptions();

  return (
    <Stack.Navigator
      initialRouteName={SUBSTITUTION_ROUTES.ChooseSubstitution}
      screenOptions={screenOptions}
    >
      <Stack.Screen
        component={ChooseSubstitutionScreen}
        name={SUBSTITUTION_ROUTES.ChooseSubstitution}
      />
      <Stack.Screen
        component={SearchCatalogScreen}
        name={SUBSTITUTION_ROUTES.SearchCatalog}
      />
      <Stack.Screen
        component={SelectSubstitutionQuantity}
        name={SUBSTITUTION_ROUTES.SelectSubstitutionQuantity}
      />
    </Stack.Navigator>
  );
};
